<template>
  <el-card>
    <el-row class="safe-strategy__title">安全策略</el-row>
    <!-- 搜索 -->
    <el-row class="safe-strategy__search">
      <span>渠道</span>
      <el-select
        v-model="search.channel"
        clearable
        filterable
        placeholder="请选择"
      >
        <el-option
          v-for="item in channelList"
          :key="item.channelId"
          :label="item.name"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span>用户群体类型</span>
      <el-select
        v-model="search.userType"
        clearable
        filterable
        placeholder="请选择"
      >
        <el-option
          v-for="item in userGroup"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span>安全策略类型</span>
      <el-select
        v-model="search.strategyType"
        clearable
        filterable
        placeholder="请选择"
      >
        <el-option
          v-for="item in safeType"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button style="margin-left: 10px" type="primary" @click="getSafe"
        >搜索</el-button
      >
      <el-button style="margin-left: 10px" type="primary" @click="add"
        >添加</el-button
      >
    </el-row>
    <!-- 表格 -->
    <el-row>
      <el-table border :data="tableList">
        <el-table-column label="策略类型" align="center">
          <template slot-scope="scope">
            {{
              safeType.find((item) => scope.row.strategyType == item.value) &&
              safeType.find((item) => scope.row.strategyType == item.value).name
            }}
          </template>
        </el-table-column>
        <el-table-column label="用户群体" align="center">
          <template slot-scope="scope">
            {{
              userGroup.find((item) => scope.row.userType == item.value) &&
              userGroup.find((item) => scope.row.userType == item.value).name
            }}
          </template>
        </el-table-column>
        <el-table-column prop="channel" label="渠道" align="center">
        </el-table-column>
        <el-table-column label="策略开关" align="center">
          <template slot-scope="scope">
            {{ scope.row.switchStatus ? '开' : '关' }}
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="创建时间" align="center">
        </el-table-column>
        <el-table-column prop="fixDate" label="修改时间" align="center">
        </el-table-column>
        <el-table-column prop="operator" label="操作人" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="200">
          <template slot-scope="scope">
            <el-button type="primary" @click="update(scope.row)"
              >编辑</el-button
            >
            <el-button type="success" @click="copy(scope.row)">复制</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 弹出框 -->
    <el-dialog
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="isShow"
      title="安全策略配置"
    >
      <el-row>
        <span style="margin-right: 10px">策略类型</span>
        <el-select
          v-model="form.strategyType"
          clearable
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="item in safeType"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-row>
      <el-row>
        <span style="margin-right: 10px">用户群体类型</span>
        <el-select
          v-model="form.userType"
          clearable
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="item in userGroup"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-row>
      <el-row>
        <span style="margin-right: 10px">渠道</span>
        <el-select
          v-model="form.channel"
          clearable
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="item in channelList"
            :key="item.channelId"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-row>
      <el-row>
        <span style="margin-right: 10px">策略开关</span>
        <el-switch
          v-model="form.switchStatus"
          active-color="#13ce66"
          :active-value="1"
          :inactive-value="0"
        >
        </el-switch>
      </el-row>
      <el-row>
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submit">确认</el-button>
      </el-row>
    </el-dialog>
  </el-card>
</template>

<script>
import { param } from 'jquery'
import { type } from 'vue-json-editor/assets/jsoneditor'

export default {
  data() {
    return {
      // 渠道
      channelList: [],
      safeType: [],
      userGroup: [],
      search: {
        userType: null,
        channel: null,
        strategyType: null,
      },
      tableList: [],
      form: {
        strategyType: null,
        userType: null,
        channel: null,
        switchStatus: 0,
      },
      isShow: false,
      //   0 添加 1 编辑
      type: 0,
    }
  },
  mounted() {
    this.getChannel()
    this.getType()
    this.getUserGroup()
    this.getSafe()
  },
  methods: {
    // 提交
    submit() {
      // console.log(this.form);
      if (this.type === 0) {
        // 添加
        this.addSafe(this.form)
      } else if (this.type === 1) {
        // 编辑
        this.changeSafe(this.form)
      }
    },
    // 添加
    add() {
      this.type = 0
      this.isShow = true
    },
    // 复制
    copy(info) {
      info = JSON.parse(JSON.stringify(info))
      this.type = 0
      this.form = {
        strategyType: info.strategyType,
        userType: info.userType,
        channel: info.channel,
        switchStatus: info.switchStatus,
      }
      this.isShow = true
    },
    // 编辑
    update(info) {
      info = JSON.parse(JSON.stringify(info))
      this.type = 1
      this.form = {
        id: info.id,
        strategyType: info.strategyType,
        userType: info.userType,
        channel: info.channel,
        switchStatus: info.switchStatus,
      }
      this.isShow = true
    },
    // 取消
    cancel() {
      this.form = {
        strategyType: null,
        userType: null,
        channel: null,
        switchStatus: 0,
      }
      this.isShow = false
    },
    //获取渠道选项
    async getChannel() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url:
          this.$store.getters.path.channelList +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.channelList = [
          { channelId: -1, name: 'all', value: 'all' },
          ...res.data,
        ]
      }
    },
    //获取安全策略类型
    async getType() {
      const { data: res } = await this.$axios({
        method: 'GET',
        url:
          this.$store.getters.path.safe_strategy_type +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.safeType = res.data
      }
    },
    //获取用户群体类型
    async getUserGroup() {
      const { data: res } = await this.$axios({
        method: 'GET',
        url:
          this.$store.getters.path.safe_strategy_userType +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.userGroup = res.data
      }
    },
    //获取安全策略
    async getSafe() {
      const { data: res } = await this.$axios({
        method: 'GET',
        url:
          this.$store.getters.path.safe_strategy_query +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        params: this.search,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.tableList = res.data
      }
    },
    //格式化时间
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property] * 1000
      if (data == null) {
        return null
      }
      let dt = new Date(data)
      return (
        dt.getFullYear() +
        '-' +
        (dt.getMonth() + 1) +
        '-' +
        dt.getDate() +
        ' ' +
        dt.getHours() +
        ':' +
        dt.getMinutes() +
        ':' +
        dt.getSeconds()
      )
    },
    // 添加安全策略
    async addSafe(info) {
      const data = JSON.parse(JSON.stringify(info))
      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.safe_strategy_add,
        data,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.getSafe()
        this.cancel()
      }
    },
    // 修改安全策略
    async changeSafe(info) {
      const data = JSON.parse(JSON.stringify(info))
      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.safe_strategy_change,
        data,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.getSafe()
        this.cancel()
      }
    },
  },
}
</script>

<style scoped lang="scss">
.safe-strategy {
  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  &__search {
    span {
      font-size: 20px;
      font-weight: 600;
      margin-right: 15px;
      margin-left: 15px;
    }

    .searchBtn {
      margin-left: 10px;
    }
  }
}
</style>
